import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import { App } from "./App";
// import { Provider } from "react-redux";
// Uncomment the line below when you're ready to use Redux
// import { store } from "./store";

// Modern Redux store with DevTools is now configured in src/store/index.ts
// When you're ready to use Redux, uncomment the import above and the Provider below

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");

const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* When ready to use Redux, uncomment this:
    <Provider store={store}>
      <App />
    </Provider>
    */}
    <App />
  </React.StrictMode>
);
